var crate_light_gallery = (function( $ ) {
	var test = 0;
	var _init = function() {
		display_gallery();
	};

	function display_gallery() {
		const lg_container = document.getElementById( 'inline-gallery-container' );

		var gallery_data = $( '#inline-gallery-container' ).data( 'gallery-images' );

		if ( typeof gallery_data === 'string' ) {
			gallery_data = JSON.parse( gallery_data );
		}

		const content_blocks_images = gallery_data.map( function( image ) {
			return {
				src:        image.src,
				responsive: image.src,
				thumb:      image.thumb
			};
		} );

		var inline_gallery = lightGallery( lg_container, {
			container:         lg_container,
			dynamic:           true,
			hash:              false,
			closable:          false,
			autoplay:          true,
			zoom:              false,
			download:          false,
			showMaximizeIcon:  true,
			appendSubHtmlTo:   '.lg-item',
			slideDelay:        200,
			slideShowInterval: 5000,
			slideShowAutoplay: true,
			autoplayControls:  true,
			plugins:           [ lgZoom, lgThumbnail, lgAutoplay ],
			dynamicEl:         content_blocks_images
		} );

		setTimeout( function() {
			inline_gallery.openGallery();
		}, 200 );

	}

	$( document ).ready( _init );

	return {};
})( jQuery );

module.exports = crate_light_gallery;